/**
 * Validates that given obj is an IFetchSourceModel
 * @param obj
 */
export function isIFetchSourceModel(obj) {
  return obj && obj.sourceType === 'fetch';
}